import React from 'react'
import { Text } from 'rebass'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom'
import { List, ListItem, Menu, MenuItem } from 'material-ui'
import { ContentAdd } from 'material-ui/svg-icons'

import leftPad from 'left-pad'

import Page from '../elements/Page'

import { newTask, clearEntries } from '../model/actions'
import { getTimeDisplay } from '../lib/time'

const EmptyState = () => {
  return (
    <Text m={4} f={4} color="#3f3e3e">
      No tasks yet. Why not add one?
    </Text>
  )
}

const TaskList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`

const TaskItem = styled.li`
  border-bottom: 1px solid #dee1e3;
  padding: 15px 20px;
  display: flex;
`

const TaskTypes = styled.span`
  margin-right: 1em;
`
const RowNumber = styled.span`
  font-style: italic;
  color: gray;
`

const Time = styled.span`
  margin-left: auto;
`

class TasksView extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      time: Date.now(),
      submitAction: 'Submit',
    }
  }
  tick = () => {
    this.setState({ time: Date.now() })
  }
  componentDidMount() {
    this.timer = setInterval(this.tick, 100)
  }
  componentWillUnmount() {
    clearInterval(this.timer)
  }
  submit = () => {
    if (this.state.submitAction === 'Submit') {
      this.setState({ submitAction: 'Really?' }, () => {
        this.submitTimeout = window.setTimeout(() => {
          this.setState({ submitAction: 'Submit' })
        }, 3000)
      })
    } else if (this.state.submitAction === 'Really?') {
      clearInterval(this.submitTimeout)
      this.setState({ submitAction: 'Sending...' }, async () => {
        const response = await window.fetch('/submit/', {
          method: 'POST',
          body: JSON.stringify(this.props.sendableState.toJS()),
          headers: {
            'Content-Type': 'application/json',
          },
        })

        if (response.ok) {
          this.setState({ submitAction: 'Success!' }, () => {
            window.setTimeout(() => {
              this.setState({ submitAction: 'Submit' })
              this.props.clearEntries()
            }, 1000)
          })
        } else {
          alert(
            'Error submitting work record.  Check your network connection and try again.',
          )
          this.setState({ submitAction: 'Submit' })
        }
      })
    }
  }
  render() {
    const { tasks, newTask, history, match } = this.props

    return (
      <Page
        title="All tasks"
        action={this.state.submitAction}
        onClick={this.submit}
        fab={<ContentAdd />}
        onFab={() => {
          const id = newTask().id
          history.push('/tasks/' + id)
        }}
      >
        {(() => {
          if (tasks.size === 0) {
            return <EmptyState />
          }

          return (
            <List>
              {tasks
                .map(t => (
                  <ListItem
                    key={t.get('id')}
                    primaryText={t.get('type').join(', ')}
                    secondaryText={getTimeDisplay(
                      t.get('startDate'),
                      t.get('endDate', this.state.time),
                    )}
                    onClick={() => {
                      history.push('/tasks/' + t.get('id'))
                    }}
                  />
                ))
                .toArray()}
            </List>
          )
        })()}
      </Page>
    )
  }
}

const mapState = state => {
  return {
    sendableState: state.data,
    tasks: state.data.get('tasks'),
  }
}

const eventMap = {
  newTask,
  clearEntries,
}

export default connect(mapState, eventMap)(withRouter(TasksView))



// WEBPACK FOOTER //
// ./src/Tasks/AllTasks.js